/* eslint-disable indent */
import React, { MouseEvent } from 'react';

import qs from 'qs';

import { useHistory } from 'models/routing';
import { History } from 'history';

const onClickHandler =
	(callback: (e: MouseEvent<HTMLAnchorElement>) => void, history: History, search?: string) =>
	(e: MouseEvent<HTMLAnchorElement>): void => {
		e.preventDefault();
		history.push({
			pathname: e.currentTarget.pathname,
			search, // onClickHandler 在這裡帶入實際上為 query sting 的動態路由, 最終 push 時帶上 query sting
		});
		callback(e);
	};

interface LinkProperty {
	className?: string;
	to?: string;
	query?: { [key: string]: string }; // 加入 query sting 物件機制以模仿動態路由
	onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
	children: React.ReactNode;
}

const Link: React.FC<LinkProperty> = ({
	className,
	to,
	query = {},
	onClick = () => {},
	children,
}) => {
	const history = useHistory();

	// 組合 query sting 與基礎路徑
	const search = qs.stringify(query, { arrayFormat: 'brackets' });
	const normalizePathWithQS = search === '' ? to : `${to}?${search}`;

	return (
		<a
			className={className}
			href={normalizePathWithQS}
			role="button"
			tabIndex={0}
			onClick={onClickHandler(onClick, history, search)} // 將 query sting 物件傳入 onClickHandler
			onKeyPress={() => {}}
		>
			{children}
		</a>
	);
};

export default Link;
